import React from "react";
import type { SectionComponentProps } from "../../registry.js";

interface HeroVideoProps {
  headline?: string;
  subheadline?: string;
  ctaLabel?: string;
  ctaTarget?: string;
  videoUrl?: string;
  overlayOpacity?: number; // 0–100, default 50
}

export function HeroVideo({ props }: SectionComponentProps) {
  const {
    headline = "Welcome",
    subheadline,
    ctaLabel,
    ctaTarget = "#reservations",
    videoUrl,
    overlayOpacity = 50,
  } = props as HeroVideoProps;

  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      {videoUrl ? (
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={videoUrl}
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-primary to-accent" />
      )}
      <div
        className="absolute inset-0 bg-black"
        style={{ opacity: overlayOpacity / 100 }}
      />
      <div className="relative z-10 text-center px-6 py-20 max-w-3xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-white leading-tight mb-6">
          {headline}
        </h1>
        {subheadline && (
          <p className="text-xl text-white/80 mb-10 max-w-xl mx-auto">{subheadline}</p>
        )}
        {ctaLabel && (
          <a
            href={ctaTarget}
            className="inline-flex items-center justify-center rounded-[var(--radius)] bg-primary px-10 py-4 text-base font-semibold text-primary-foreground shadow-lg hover:opacity-90 transition-opacity"
          >
            {ctaLabel}
          </a>
        )}
      </div>
    </section>
  );
}
